import React from "react";
import T from "prop-types";
import _ from "lodash";
import { Map } from "immutable";
import { toggleSwitch, translateProps } from "MODULES/shared/decorators";
import { Authorized, Icon } from "MODULES/shared/components";
import { API_BASE } from "APP_ROOT/constants";
import {
  QUALITY_CONTROL,
  CREATE_PACKING_SLIP,
  WAREHOUSE_EXPERT,
  WAREHOUSE_MANAGER,
  WAREHOUSE_LOGISTICS_DIRECTOR,
  REPAIR
} from "MODULES/users/constants";
import {
  DISCREPANCY_REPORTED,
  INVENTORY,
  QC_HOLD,
  QC_STATUS,
  STATUS,
  UNDER_REVIEW
} from "MODULES/inventories/constants";
import DownloadPackingSlipModal from "MODULES/shared/components/DownloadPackingSlipModal/DownloadPackingSlipModal";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { hasRole } from "MODULES/users/helpers";
import DownloadPackingSlipLink from "./DownloadPackingSlip/DownloadPackingSlip";

export function DownloadPackingSlip({
  close,
  salesOrder,
  url,
  open,
  downloading
}) {
  return (
    <Authorized
      permissions={[CREATE_PACKING_SLIP]}
      roles={[QUALITY_CONTROL]}
      subroles={[
        WAREHOUSE_EXPERT,
        WAREHOUSE_MANAGER,
        WAREHOUSE_LOGISTICS_DIRECTOR
      ]}
      authorizedIf={user =>
        hasRole(user.toJS(), REPAIR) &&
        !salesOrder.accounting_hold &&
        !salesOrder.line_items.some(
          f =>
            _.get(f, [INVENTORY, STATUS].join(".")) === DISCREPANCY_REPORTED ||
            [UNDER_REVIEW, QC_HOLD].includes(
              _.get(f, [INVENTORY, QC_STATUS].join("."))
            )
        )}
    >
      {salesOrder.line_items.length > 1 ? (
        <DropDownItem
          onClick={open}
          faIcon="file-text-o"
          label="Download Packing Slip"
        >
          <DownloadPackingSlipModal
            partKey="part.part_number"
            record={salesOrder}
            open={downloading}
            close={close}
            url={url}
          />
          <Icon name="file-text-o" fixed />
          &nbsp;Download Packing Slip
        </DropDownItem>
      ) : (
        <DownloadPackingSlipLink />
      )}
    </Authorized>
  );
}

DownloadPackingSlip.propTypes = {
  downloading: T.bool.isRequired,
  close: T.func.isRequired,
  open: T.bool.isRequired,
  url: T.string.isRequired,
  salesOrder: T.instanceOf(Map)
};

const withUrl = translateProps(({ salesOrder }) => ({
  url: `${API_BASE}/sales_orders/${salesOrder.id}/download_packing_slip?discreet=false`
}));

export default withUrl(toggleSwitch("downloading")(DownloadPackingSlip));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/DownloadPackingSlip.jsx